import React from 'react';
import { useSelector } from 'react-redux';

import { FormikHelpers } from 'formik';
import { RootState } from 'store';

import CurrencyInput from 'components/CurrencyInput';

interface Props {
  name?: string;
  value?: number;
  placeHolder?: string;
  darkPlaceholder?: boolean;
  error?: string;
  disabled?: boolean;
  countryCurrency?: string;
  formik?: FormikHelpers<number>;
  onChange?: (event: React.SyntheticEvent, maskValue: string, value: number) => void;
}

const CurrencyInputContainer = (props: Props) => {
  const { accountResult } = useSelector((state: RootState) => state.user);
  if (!accountResult) return null;
  const { countryCurrency } = accountResult;

  return <CurrencyInput countryCurrency={accountResult.countryCurrency ?? countryCurrency} {...props} />;
};

export default CurrencyInputContainer;
